import type { TabsDesignTokens } from '@primeuix/themes/types/tabs';

/**
 * Tabs component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tabs/index.ts
 *
 * Component documentation:
 * https://primeng.org/tabs
 */
export const tabsComponentTokens: Partial<TabsDesignTokens> = {
  tablist: {
    background: 'transparent',
  },
  tab: {
    padding: '1rem',
    color: '{text.secondary}',
    activeColor: '{text.color}',
    borderColor: '{border.main}',
    activeBorderColor: '{primary.color}',
    hoverBorderColor: '{primary.color}',
  },
  tabpanel: {
    background: 'transparent',
    padding: '1.5rem 1rem',
  },
  activeBar: {
    background: '{primary.color}',
    height: '2px',
  },
};
